/**
 * 轻量合规过滤：去掉疑似密码 / 完整卡号等属性值。
 */

const SENSITIVE_KEY_RE =
  /(password|passwd|pwd|pay_pwd|paypwd|token|secret|otp|verify_code|verifycode|id_card|idcard|bank_card|bankcard|card_no|cardno)/i
const CARD_LIKE_RE = /\b\d{13,19}\b/

export function sanitizeAnalyticsProps(input: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(input)) {
    if (SENSITIVE_KEY_RE.test(key)) continue
    if (typeof value === 'string') {
      const trimmed = value.trim()
      if (CARD_LIKE_RE.test(trimmed) && trimmed.replace(/\s/g, '').length >= 13) continue
      if (trimmed === 'null' || trimmed === 'undefined') {
        out[key] = ''
        continue
      }
    }
    if (value === null) continue
    out[key] = value
  }
  return out
}
